<template>
  <v-layout column align-center>
    <v-flex>
      <h3>Please click Upload to upload <span>.csv/.xlsx</span> file</h3>
    </v-flex>
    <v-flex>
      <e-upload
        :url="uploadUrl"
        :extensions="['.csv', '.xlsx']"
        :disabled="!isWriteAvailable" />
    </v-flex>
  </v-layout>
</template>

<script>
import EUpload from './../../shared/Upload'
import mixins from '@/utils/mixins'
import { api } from '@/modules/api'

export default {
  name: 'MultipleInvitation',
  mixins: [mixins.isWriteAvailable],
  components: {
    EUpload
  },
  data () {
    return {
      uploadUrl: api.invitationMultiply.getMultiplyBlitzLink(),
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'blitz:write'
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/BlitzInvitation/multiple.vue